import React from "react";
import {
  Box,
  Typography,
  Stack,
} from "@mui/material";
import moment from "moment";
import EventCard from "./EventCard";

function CustomDailyAgenda({ date, events, onBack }) {

  // 1. Filter the events to only those that fall on the selected date
  const todaysEvents = events.filter((event) => {
    const isSameDay = moment(event.eventDate).isSame(date, "day");
    // Also include multi-day events that span across this day
    const isSpanning = moment(date).isBetween(
      event.eventDate,
      event.endDate,
      "day",
      "[]",
    );
    return isSameDay || isSpanning;
  });

  return (
    <Box sx={{ p: { xs: 1, sm: 2 }, maxWidth: 700, margin: "0 auto" }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
          px: 1,
        }}
      >
        <Typography
          variant="h5"
          component="h2"
          sx={{
            fontWeight: 800,
            fontSize: { xs: "1.5rem", sm: "2rem" },
            color: "text.primary",
          }}
        >
          {moment(date).format("dddd, Do MMMM")}
        </Typography>
      </Box>

      {/* The Event Cards */}
      <Stack spacing={2}>
        {todaysEvents.length === 0 ? (
          <Box
            sx={{
              py: 5,
              textAlign: "center",
              backgroundColor: "#f9f9f9",
              borderRadius: 3,
            }}
          >
            <Typography sx={{ color: "text.secondary", fontSize: "1.1rem" }}>
              No events scheduled for this day.
            </Typography>
          </Box>
        ) : (
          todaysEvents.map((event) => {
            return <EventCard key={event.eventID} event={event} />;
          })
        )}
      </Stack>
    </Box>
  );
}

export default CustomDailyAgenda;
